import { networkToTopicIdentifiersMap } from 'hb-react/shared/constants/pageIdentifiers';
import { type PageIdentifier } from 'hb-react/shared/constants/pageIdentifiers';

export const getNameFromMenu = (menu, identifier) => {
  if (!menu || !identifier) {
    return undefined;
  }

  for (let i = 0; i < menu.length; i += 1) {
    const item = menu[i];

    if (item.identifier === identifier) {
      return item.menu_name;
    }

    if (item.menu?.identifier === identifier) {
      return item.menu.menu_name;
    }

    if (item.submenus) {
      const name = getNameFromMenu(item.submenus, identifier);

      if (name) {
        return name;
      }
    }
  }

  return undefined;
};

export const getTopicPageIdentifier = (
  identifier: PageIdentifier,
): PageIdentifier => networkToTopicIdentifiersMap[identifier];
